/**
 * Sends a POST request to subscribe an email to the newsletter
 * Passes in an optional sector Id
 * @param {string} email
 *
 * @returns {Promise}
 */
async function subscribeToNewsletter(email) {
  try {
    let response = await fetch(
      `${location.origin}/wp-json/reports/subscription`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();
    return JSON.parse(data.body);
  } catch (error) {
    return error;
  }
}

export default subscribeToNewsletter;
